import { SUPPORTED_LANG } from "@/shared/config/localstorage";
import type { PointsInfo } from "../model/pointsActions";
import { formatGain, type SphereKey } from "../model/spheres";

/**
 * Что чип сообщает окну «за что эти баллы» (PointsInfoRoot): действие, уточнение и
 * число ровно как на чипе. Окно ловит нажатия по data-points-chip на всём сайте.
 */
export const pointsInfoAttrs = (info?: PointsInfo | null): Record<string, string> => {
    if (!info) return {};
    const out: Record<string, string> = { "data-points-action": info.action };
    if (info.ctx) out["data-points-ctx"] = info.ctx;
    if (info.amount != null && info.amount !== "") {
        out["data-points-amount"] = typeof info.amount === "number" ? formatGain(info.amount) : info.amount;
    }
    return out;
};

/**
 * Любая строка «+N» становится чипом окна «за что эти баллы»: нажатие (и Enter/пробел)
 * открывает окно. Для своих элементов страниц (строки «Моего обучения», диета, умный
 * поиск, меню) — те же атрибуты, что у общего PointsChip.
 */
export const pointsChipAttrs = (sphere: SphereKey, info?: PointsInfo | null, label?: string) => ({
    "data-points-chip": "",
    "data-sphere": sphere,
    role: "button" as const,
    tabIndex: 0,
    "aria-haspopup": "dialog" as const,
    ...(label ? { "aria-label": label } : {}),
    ...pointsInfoAttrs(info),
});

/**
 * Экран «Как получить баллы» (и его лист «Подробнее») помечен этим атрибутом: окно,
 * открытое с его строки, не показывает «Все баллы: <сфера>» — человек уже там.
 */
export const POINTS_RULES_ATTR = "data-points-rules";

/**
 * Язык сайта из адреса (/de/account/…) — для ссылки «Все баллы: …», чтобы она вела на
 * страницу того же языка. Адрес без языка — язык i18n, иначе en.
 */
export const siteLangOf = (pathname: string, fallback?: string | null): string => {
    const seg = (pathname.split("/")[1] || "").toLowerCase();
    if (SUPPORTED_LANG.includes(seg)) return seg;
    const f = (fallback || "").slice(0, 2).toLowerCase();
    if (f === "zh") return "cn";
    return SUPPORTED_LANG.includes(f) ? f : "en";
};
